module.exports = __webpack_public_path__ + "static/media/logo_option3.95ce6032.png";